import styled, { keyframes } from 'styled-components';
import { ButtonStyledProps } from './button.component';

const loaderKeyframes = keyframes`
  from {
    transform: rotate(0) translate(-50%, -50%);
  }
  to {
    transform: rotate(2000deg) translate(-50%, -50%);
  }
`;

export const ButtonStyled = styled('button')<ButtonStyledProps>`
  display: block;
  border: 1px solid #da291c;
  border-radius: 25px;
  position: relative;
  background-color: ${props => (props.secondary ? '#fff' : '#da291c')};
  cursor: pointer;
  font-size: 1.1em;
  padding: 0 25px;
  min-width: 190px;
  color: ${props => (props.secondary ? '#da291c' : '#fff')};
  overflow: hidden;
  height: 45px;

  &:focus {
    outline: none;
  }

  &.has-loader {
    pointer-events: none;
    &::before {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      background-color: #da291c;
    }
    &::after {
      content: '';
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 18px;
      height: 18px;
      background-image: url(data:image/svg+xml;base64,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);
      z-index: 4;
      transform-origin: 0 0;
      animation: ${loaderKeyframes} 5s linear forwards infinite;
    }
  }

  &.has-word-wrap {
    min-width: 236px;
    height: 68px;
    font-size: inherit;
    border-radius: 38px;
  }

  &.centered {
    margin: 0 auto;
  }

  &.disabled {
    ${props => props.disableClickHandler && "pointer-events: none;"}
    opacity: 0.4;
  }

  &.full-width {
    width: 100%;
    max-width: 340px;
  }
`;
